import axios from "axios";
import { jwtDecode } from "jwt-decode";
import i18n from "../config/languageInit";

// Add a response interceptor
axios.interceptors.response.use(
  /**
   *
   * @param {import("axios").AxiosResponse} response
   * @returns
   */
  function (response) {
    // Do something with response data
    return response;
  },
  function (error) {
    // Do something with response error
    if (error.response.status === 401) {
      var token = localStorage.getItem("jwtToken");
      var tokenDate = new Date();
      var now = new Date();
      var decoded = null;
      if (token === "undefined") {
        window.location.href = "/auth/login";
      }
      if (token !== null && token !== "undefined") {
        decoded = jwtDecode(token);
        tokenDate = new Date(decoded.exp * 1000);
      }
      if (tokenDate < now && decoded !== null) {
        localStorage.removeItem("jwtToken");
        decoded = null;
        window.location.href = "/auth/login";
      }
      window.location.href = "/unauthorized";
    }
    console.error(error);
    return Promise.reject(error);
  }
);

export function axiosRequestMiddleware(config) {
  const token = localStorage.getItem("jwtToken");
  if (token) {
    config.headers.set("Authorization", `Bearer ${token}`);
  }
  config.headers.set("Accept-Language", i18n.language);
  return config;
}
